import { cloneDeep } from 'lodash-es'

export type DeepPartial<T> = Partial<{ [P in keyof T]: DeepPartial<T[P]> }>

export function toRaw<T>(data: Record<string | number, any>): T {
  return cloneDeep(data ?? {}) as T
}

export type Cleanup = () => void
